import Logo from "../../assets/images/icons/ogwugo-o.svg";

const FirebaseMessage = ({ notification }) => {
  return (
    <>
      <div id="notificationHeader" className="flex gap-3 mb-1">
        {/* image is optional */}

        <div id="imageContainer">
          <img
            src={notification.image || Logo}
            width={20}
            height={20}
            alt="notify"
          />
        </div>

        <span className="font-bold capitalize">{notification.title}</span>
      </div>
      <div id="notificationBody">{notification.body}</div>
    </>
  );
};

export default FirebaseMessage;
